import {
    Component,
    ContentChild,
    ContentChildren,
    EventEmitter,
    Input,
    Output,
    QueryList,
    TemplateRef
} from '@angular/core';
import { NavigationItem } from '../../../models/common';
import { LsqBaseNavigationComponent } from '../base-navigation/lsq-base-navigation.component';

@Component({
    selector: 'lsq-navigation',
    templateUrl: './lsq-navigation.component.html',
    styleUrls: ['./lsq-navigation.component.scss']
})
export class LsqNavigationComponent extends LsqBaseNavigationComponent {
    @ContentChild('rightNavItems') public rightNavItems: TemplateRef<any>;
    @ContentChild('loggedOutRightNavItems') public loggedOutRightNavItems: TemplateRef<any>;
    @ContentChildren('settingsDropdownPrepend') public settingsDropdownPrepend: QueryList<
        TemplateRef<any>
    >;
    @ContentChildren('settingsDropdownAppend') public settingsDropdownAppend: QueryList<
        TemplateRef<any>
    >;
    @Input() public useMaxWidth = true;
    @Input() public showNavigationChildren = true;
    @Input() public hideNavigationItems = false;
    @Input() public collapseForMobile = true;
    @Input() public navLogoTemplate: TemplateRef<any>;
    @Input() public showBetaLogo = false;
    @Input() public forceRenderAccountDropdown = false;
    @Output() public openMobile = new EventEmitter();
    public gearDropdownIsExpanded = false;
    public isAllowAnonymous = (item: NavigationItem) => item.allowAnonymous;

    public openMobileNavigation(): void {
        this.openMobile.emit();
    }

    public closeGearDropdown(): void {
        this.gearDropdownIsExpanded = false;
    }

    public toggleGearDropdown(): void {
        this.gearDropdownIsExpanded = !this.gearDropdownIsExpanded;
    }
}
